// Search engines cut a <title> at about 60 characters and a meta
// description at about 160. Ahrefs flags a title over 60 characters and a
// description under 110 or over 160 characters.
export const TITLE_MAX = 60;
export const DESCRIPTION_MAX = 155;

/**
 * "<title> | <brand>" when that fits in TITLE_MAX characters. If it does
 * not fit, the page title alone, because the words of the title matter
 * more than the brand suffix.
 */
export function brandedTitle(title: string, brand: string): string {
  const full = `${title} | ${brand}`;
  return full.length <= TITLE_MAX ? full : title;
}

/** Plain text of an HTML fragment, with the whitespace collapsed. */
export function htmlToText(html: string): string {
  return html
    .replace(/<[^>]+>/g, " ")
    .replace(/&nbsp;/g, " ")
    .replace(/&amp;/g, "&")
    .replace(/&#x27;|&#39;/g, "'")
    .replace(/&quot;/g, '"')
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/\s+/g, " ")
    .trim();
}

/** Cut text at a word boundary to at most `max` characters, with "…". */
export function snippet(text: string, max = DESCRIPTION_MAX): string {
  const clean = text.replace(/\s+/g, " ").trim();
  if (clean.length <= max) return clean;
  const cut = clean.slice(0, max - 1);
  const lastSpace = cut.lastIndexOf(" ");
  return `${(lastSpace > 0 ? cut.slice(0, lastSpace) : cut).replace(/[\s,;:.-]+$/, "")}…`;
}
